export class ToastOptions {
    constructor(
        public variant: string,
        public subtitle: string,
        public title: string,
        public content: string,
        public toaster: string
    ) {}
}